import {
  ActionIcon,
  Badge,
  Card,
  ColorSwatch,
  Group,
  Image,
  Text,
} from "@mantine/core";
import { IconExternalLink, IconUsersGroup } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { parseDate } from "../../../../functions/dates";
import { useLanguage } from "../../../../stores/LanguageStore";

const Status = ({ item }) => {
  return (
    <ActionIcon
      component={Link}
      to={`https://${item?.domain_saas3 || item?.domain_saas2}`}
      target="_blank"
      variant="light"
      size={"lg"}
      onClick={(e) => e.stopPropagation()}
      disabled={!item?.domain_saas3 && !item?.domain_saas2}
    >
      <IconExternalLink size={24} />
    </ActionIcon>
  );
  // return (
  //   <ThemeIcon color="green" variant="light" size={"lg"} radius={"xl"}>
  //     <IconCheck />
  //   </ThemeIcon>
  // );
};

const ResellerItem = ({ item }) => {
  const lang = useLanguage((s) => s.language);
  return (
    <Card
      withBorder
      padding="md"
      component={Link}
      to={`/resellers/${item.id}`}
      className="reseller-item"
      radius={"md"}
      pos={"relative"}
      style={{ boxShadow: "1px solid #00000012" }}
      h={300}
    >
      <Group
        pos={"absolute"}
        top={8}
        left={0}
        right={0}
        px={"md"}
        justify="space-between"
      >
        <Group gap={"sm"}>
          <ColorSwatch color={`#${item.color_primary}`} size={16} />
          <ColorSwatch color={`#${item.color_secondary}`} size={16} />
        </Group>

        <Status item={item} />
      </Group>

      <Image
        src={item.logo_url}
        mt={60}
        w={"80%"}
        mx={"auto"}
        h={75}
        style={{ objectFit: "contain" }}
      />

      <Text fw={500} ta={"center"} size="xl" mt={"auto"}>
        {item.name}
      </Text>

      <Group justify="center" gap={"lg"} mt={16}>
        <Badge
          radius={"md"}
          size="xl"
          leftSection={<IconUsersGroup size={18} />}
          variant="light"
          styles={{
            label: {
              marginLeft: 12,
            },
          }}
        >
          {item.number_of_users}
        </Badge>
      </Group>

      <Text size="sm" mt={16} ta={"center"} c={"dimmed"}>
        {lang.white_labels.created_on} : {parseDate(item.created_on)}
      </Text>
    </Card>
  );
};

export default ResellerItem;
